import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "soon container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "soon__title title" }, "Скоро появится", -1)
const _hoisted_3 = { class: "soon__list" }
const _hoisted_4 = ["index"]
const _hoisted_5 = { class: "item__title" }
const _hoisted_6 = { class: "item__content" }
const _hoisted_7 = { class: "item__desc" }
const _hoisted_8 = {
  key: 0,
  class: "item__gallery"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "soon__more" }, "И еще 17 нововведений", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          index: index,
          class: "soon__item item"
        }, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(item.title), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", {
              class: "item__stick",
              style: _normalizeStyle(`background-image:url('${_ctx.IMAGE_BASE_URL}soon-stick.svg')`)
            }, null, 4),
            _createElementVNode("p", _hoisted_7, _toDisplayString(item.desc), 1),
            (item.img)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.img, (img, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: "item__image"
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.IMAGE_BASE_URL + img,
                        alt: ""
                      }, null, 8, _hoisted_9)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_4))
      }), 128))
    ]),
    _hoisted_10
  ]))
}